import React from 'react';
import { motion } from 'framer-motion';
import { Calendar, Clock, Rocket } from 'lucide-react';
export function Plan48() {
  const steps = [{
    icon: Calendar,
    time: 'Sábado Mañana',
    desc: 'Eliges tu tema y dejas que la IA cree tu producto.',
    color: 'text-blue-500',
    bg: 'bg-blue-500/10'
  }, {
    icon: Clock,
    time: 'Sábado Tarde',
    desc: 'Diseñas tu portada y configuras tu link de pago.',
    color: 'text-purple-500',
    bg: 'bg-purple-500/10'
  }, {
    icon: Rocket,
    time: 'Domingo',
    desc: "Publicas tus primeros videos 'Sin Rostro' y empiezas a recibir mensajes.",
    color: 'text-primary',
    bg: 'bg-primary/10'
  }];
  return <section className="bg-light py-24 px-4 relative overflow-hidden pt-[50px] pb-[50px]" data-id="element-161">
      <div className="max-w-4xl mx-auto relative z-10" data-id="element-162">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-163">
          <span className="text-primary font-bold uppercase tracking-wider text-sm" data-id="element-164">
            El Plan de 48 Horas
          </span>
          <h2 className="text-3xl md:text-5xl text-dark font-display font-extrabold tracking-headline mt-2" data-id="element-165">
            Tu Fin de Semana de Transformación
          </h2>
        </motion.div>

        <div className="relative" data-id="element-166">
          {/* Vertical Line for Desktop */}
          <div className="hidden md:block absolute left-1/2 top-0 bottom-0 w-0.5 bg-border -translate-x-1/2" data-id="element-167"></div>

          <div className="space-y-12" data-id="element-168">
            {steps.map((step, idx) => <motion.div key={idx} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: idx * 0.2
          }} className={`flex flex-col md:flex-row items-center gap-8 ${idx % 2 === 0 ? 'md:flex-row-reverse' : ''}`} data-id="element-169">
                <div className={`flex-1 w-full ${idx % 2 === 0 ? 'md:text-left' : 'md:text-right'}`} data-id="element-170">
                  <div className={`inline-block px-4 py-1.5 rounded-full ${step.bg} ${step.color} font-bold text-sm mb-4`} data-id="element-171">
                    {step.time}
                  </div>
                  <p className="text-xl text-body leading-relaxed font-medium" data-id="element-172">
                    {step.desc}
                  </p>
                </div>

                <div className="flex-shrink-0 w-16 h-16 rounded-full bg-white border-4 border-light flex items-center justify-center relative z-10 shadow-xl" data-id="element-173">
                  <step.icon className={`w-6 h-6 ${step.color}`} data-id="element-174" />
                </div>

                <div className="flex-1 hidden md:block" data-id="element-175"></div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}